//////////////////////////////////////////////////////////////////////////////
// Платеж через виджет
//////////////////////////////////////////////////////////////////////////////
var paymentHandler = function(e, amount, email, user_id, tour_id, tourInfo, type, successCallback, failCallback) {
    e.preventDefault();
    reachGoal('start_balance');

    var title = 'Пополнение баланса';
    if (type == 'payment') {
        title = 'Оплата брони';
    }

    var payments = new cp.CloudPayments({
        startWithButton: false
    });
    payments.charge({
            // Боевой
            publicId: 'pk_042039467a74ac7f4026151e34093',
            // Тестовый
            //publicId: 'pk_98f5667b3fdbf1f45babf95e7f3b1',
            description: title,
            amount: amount,
            currency: 'RUB',
            accountId: user_id,
            email: email,
            data: {
                user_id: user_id,
                tour_id: tour_id,
                type: type,
                tourInfo: tourInfo
            }
        },
        successCallback,
        failCallback
    );
};

//////////////////////////////////////////////////////////////////////////////
// Реккаринговый платеж
//////////////////////////////////////////////////////////////////////////////
var paymentReccuringHandler = function(e, token, amount, type, tour_id, tourInfo, successCallback, failCallback) {
    e.preventDefault();
    reachGoal('start_balance');

    $.post('/pay/payWithCard', {
        token: token,
        amount: amount,
        type: type,
        tour_id: tour_id,
        tourInfo: tourInfo
    }, function(response) {
        if (response.success) {
            successCallback(response);
        } else {
            failCallback(response.message, response);
        }
    }, 'json');
};

//////////////////////////////////////////////////////////////////////////////
// Методы Callback для приема платежей
//////////////////////////////////////////////////////////////////////////////
var successCharge = function(options) {
    reachGoal('ok_transact');

    $('#chargeButton').removeAttr('disabled');

    var amount = 0;
    if (options.amount) {
        amount = options.amount;
    }

    if ($('#back_link').length > 0) {
        var redirectLink = $('#back_link').val();
        window.location.href = redirectLink + '&amount=' + amount;
    } else {
        window.location.href = '/user/personalAccount?amount=' + amount + '&tour_id=' + options.data.tour_id;
    }
};

var failCharge = function(reason, options) {
    reachGoal('break_transact');

    if ($('#paymentErrorMessage').length > 0) {
        $('#paymentErrorMessage').html('Платеж отклонен по причине: <span>' + reason + '</span>');
    }

    $('#chargeButton').removeAttr('disabled');
};

var successPayment = function(options) {
    $('#paymentFormButton').removeAttr('disabled');
    window.location.reload();
};

var failPayment = function(reason, options) {
    $('#paymentFormButton').removeAttr('disabled');
};

//////////////////////////////////////////////////////////////////////////////
// Методы замены HTML кода формы
//////////////////////////////////////////////////////////////////////////////
function replaceForm($form, formHtml) {
    $form.html(formHtml);
    initCheckbox();
    initInputMask();
}

function initCheckbox() {
    $('.i-check, .i-radio').iCheck({
        checkboxClass: 'i-check',
        radioClass: 'i-radio'
    });
}

function initInputMask() {
    $(".phoneMask").inputmask("+7 (999) 999-99-99");
}

$(document).ready(function() {
    //////////////////////////////////////////////////////////////////////////////
    // Обработка событий формы пополнения
    // Форма находится в виде user/_personal_account_form.php
    //////////////////////////////////////////////////////////////////////////////
    $('#personal_account_form')
        .on('submit', 'form', function(e) {
            e.preventDefault();
            var $button = $(this).find('input:submit');

            if ($('#paymentErrorMessage').length > 0) {
                $('#paymentErrorMessage').html('');
            }

            var $form = $(this).closest('form');
            var from = $form.data('from');
            $($form).ajaxSubmit({
                dataType: 'json',
                url: '/user/validateBalanceForm',
                target: '#personal_account_form',
                async: false,
                success: function(response) {
                    // Если форма валидна
                    if (response.success == true) {
                        $button.attr('disabled', 'disabled');

                        // Теперь проверим, не платроном ли нам нужно произвести прием денег
                        if (response.payData.isPlatron) {
                            reachGoal('start_balance_platron');
                            setTimeout(function() {
                                window.location.href = response.payData.platronLink;
                            }, 500);
                            return false;
                        }

                        // В случае, если пользователь хочет платить картой
                        if (response.payData.token == 'withoutToken') {
                            // Запуск скрипта платежного шлюза
                            var tourId = $form.find('#tour_id').val() || null;
                            paymentHandler(e, response.payData.amount, response.payData.email, response.payData.user_id, tourId, {}, response.payData.type, successCharge, failCharge);
                        } else {
                            var title = 'Пополнить баланс на ' + response.payData.amountPretty + '?';

                            swal({
                                    title: title,
                                    text: '',
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#2A8FBD",
                                    confirmButtonText: 'Да',
                                    cancelButtonText: "Отмена",
                                    closeOnConfirm: true,
                                    closeOnCancel: true,
                                    allowHTML: true
                                },
                                function(isConfirm) {
                                    if (isConfirm) {
                                        var tourId = $form.find('#tour_id').val() || null;
                                        // Отправка запроса на оплату реккаринговым платежом
                                        paymentReccuringHandler(e, response.payData.token, response.payData.amount, response.payData.type, tourId, {}, successCharge, failCharge);
                                    } else {
                                        $button.removeAttr('disabled');
                                    }
                                }
                            );
                        }
                    } else {
                        $form.html(response.form);
                        initCheckbox();
                        initInputMask();

                        // В случае лшибок, обновить вид формы
                        //replaceForm($form, response.form);
                    }
                }
            });
        })
        .on('click', '.checkRadio > td', function(e) {
            e.preventDefault();
            var $tr = $(this).closest('tr');
            $tr.find('input.chargeToken').iCheck('check');
        });

    $('a.show-warning').on('click', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var title = 'Подтвердите, что понимаете и хотите выполнить данное действие';
        var confirmButtonLabel = 'Подтверждаю';

        if ($(this).hasClass('action-delete')) {
            title = 'Удалить карту?';
            confirmButtonLabel = 'Удалить';
        }

        swal({
                title: title,
                text: '',
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#2A8FBD",
                confirmButtonText: confirmButtonLabel,
                cancelButtonText: "Отмена",
                closeOnConfirm: true,
                closeOnCancel: true,
                allowHTML: true
            },
            function(isConfirm) {
                if (isConfirm) {
                    window.location = url;
                }
            }
        );

        return false;
    });

    //////////////////////////////////////////////////////////////////////////////
    // Обработка события оплаты
    // Форма находится в виде reservation/_payment_form.php
    //////////////////////////////////////////////////////////////////////////////
    $('#payment_form')
        .on('click', '#paymentFormButton', function(e) {
            e.preventDefault();
            var $button = $(this);

            var $form = $(this).closest('form');
            $($form).ajaxSubmit({
                dataType: 'json',
                target: '#payment_form',
                async: false,
                success: function(response) {

                    // Если форма валидна
                    if (response.success == true) {
                        $button.attr('disabled', 'disabled');

                        // Теперь проверим, не платроном ли нам нужно произвести прием денег
                        if (response.payData.isPlatron) {
                            reachGoal('start_balance_platron');
                            setTimeout(function() {
                                window.location.href = response.payData.platronLink;
                            }, 500);
                            return false;
                        }

                        // Если пользователь будет оплачивать лот с своего счета целиком
                        if (response.payWithBalance) {
                            $form.attr('action', response.linkToPayWithBalance);
                            $form.submit();
                        } else {
                            // В случае, если пользователь хочет платить картой
                            if (response.payData.token == 'withoutToken') {
                                // Запуск скрипта платежного шлюза
                                paymentHandler(e, response.payData.amount, response.payData.email, response.payData.user_id, response.payData.tour_id, response.payData.tourInfo, response.payData.type, successPayment, failPayment);
                            } else {
                                var title = 'Оплатить ' + response.payData.amountPretty + ' с сохраненной карты?';

                                swal({
                                        title: title,
                                        text: '',
                                        type: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#2A8FBD",
                                        confirmButtonText: 'Да',
                                        cancelButtonText: "Отмена",
                                        closeOnConfirm: true,
                                        closeOnCancel: true,
                                        allowHTML: true
                                    },
                                    function(isConfirm) {
                                        if (isConfirm) {
                                            // Отправка запроса на оплату реккаринговым платежом
                                            paymentReccuringHandler(e, response.payData.token, response.payData.amount, response.payData.type, response.payData.tour_id, response.payData.tourInfo, successPayment, failPayment);
                                        } else {
                                            $button.removeAttr('disabled');
                                        }
                                    }
                                );
                            }
                        }
                    } else {
                        $form.html(response.form);
                        initCheckbox();
                        initInputMask();

                        // replaceForm($form, response.form);
                    }
                }
            });
        }).on('click', '.checkRadio > td', function(e) {
            e.preventDefault();
            var $tr = $(this).closest('tr');
            $tr.find('input.chargeToken').iCheck('check');
        });
});
